<template>

<div>
    <el-alert type="warning" title="Searching &amp; Sorting still under development" show-icon />

    <data-table
      :id="getTableRef()"
      :ref="getTableRef()"
      :title="title"
      :url="url"
      :table-ref="getTableRef()"
      :fields="fields"
      :hideTop="hideTop"
      :perPage="5"
      :sort-field="['status', 'siteName', 'upload_at', 'upload_by', 'title']"
      :showSearch="showSearch"
      :showRefresh="showRefresh"
      :searchPlaceholder="searchPlaceholder"
      :show-pagination="showPagination"
      :params="stepData">
<!--
      :add-props="addProps"
      :add-action="(uploadInfo || uploadCallback) ? addFileAction : null"
      detail-component="file-detail-row">
    -->

      <template slot="file-details" slot-scope="props">
        <el-card shadow="hover">
          <h4><i :class="formatStatus(props.rowData.status)">{{props.rowData.status}}</i>:
            &nbsp;{{props.rowData.siteName}}</h4>
          <b :class="formatRequest(props.rowData.RTx)">{{props.rowData.RTx}}</b>
          <p><small>{{props.rowData.siteId}}</small> <b class="pull-right">{{props.rowData.shortName}}</b></p>

          <center>
            <el-form>
              <file-upload
                v-if="!props.rowData.url"
                  :text="'Upload ' + props.rowData.title"

                  :url="getEndpoint('/upload/' +
                    props.rowData.id + '/site/' +
                    props.rowData.site_id + '/' + org().name)"

                  :delete-file-only="true"
                  :after-upload="uploaded"
                  :after-delete="afterDelete"
                  :model="getModel(props.rowData.id)"
                  type="primary"
                  :show-tooltip="true"
                  :size="size"
                  :additional-data="uploadInfo"
                  :disabled="isViewOnly() || disableUpload(props.rowData)">
              </file-upload>

              <div v-else>
                <el-row type="flex" justify="center" :gutter="12">
                  <el-col align="right">
                    <popup
                      :heading="'View ' + props.rowData.title + ' (' + props.rowData.name + ')'"
                      button-text="View"
                      button-icon="fa fa-eye"
                      button-style="primary"
                      overide-view-only
                      :show-save="false">
                      <pdf-viewer :url="getEndpoint('/file/view/' + props.rowData.url)" />
                    </popup>
                  </el-col>

                  <el-col align="left">
                    <el-button
                      :type="getType(props.rowData)"
                        @click="download(props.rowData)"
                        size="mini"
                        :disabled="isViewOnly()">
                        <b><i class="fa fa-download" />&nbsp;Download</b>
                      </el-button>
                    </el-col>
                  </el-row>
                  <p v-if="showFileName && isDesktop">
                    <b>{{props.rowData.title}}</b> | <i>{{props.rowData.name}}</i>
                  </p>
                </div>
              </el-form>
            </center>

            <el-row :gutter="12">

              <el-col :span="8" align="left">
                File Size: <b>{{formatKiloBytes(props.rowData.size)}}</b>
              </el-col>

              <el-col :span="8" align="center">
                Upload at: <b>{{formatFriendlyDate(props.rowData.upload_at)}}</b>
              </el-col>

              <el-col :span="8" align="right">
                Upload By: <b>{{props.rowData.upload_by}}</b>
              </el-col>

            </el-row>

        </el-card>
      </template>


    </data-table>
  </div>
</template>


<script>
import Vue from 'vue'

import PostMixins from '@/mixins/PostMixins'
import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import FileAction from '@/components/actions/FileAction'

import Popup from '@/components/atoms/Popup'
import PdfViewer from '@/components/atoms/PdfViewer'

import FileDetails from '@/components/tables/details/FileDetails'

import FileUpload from '@/components/atoms/files/FileUpload'
import FileDownload from '@/components/atoms/files/FileDownload'

Vue.component('file-detail-row', FileDetails)

export default {
  mixins: [PostMixins, ArrayMixins, DateMixins, NumberMixins],

  components: {
    FileAction,
    FileDownload,
    FileUpload,
    PdfViewer,
    Popup
  },

  props: {
    siteId: {
      type: Number,
      default: null
    },

    type: {
      type: String,
      default: 'site'
    },

    typeId: {
      type: Number,
      default: null
    },

    step: {
      type: Number,
      default: null
    },

    partyNo: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    showFileName: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Search'
    },

    uploadInfo: {
      type: Object,
      default: null
    },

    uploadCallback: {
      type: Function,
      default: null
    },

    tableRef: {
      type: String,
      default: 'filestable'
    },

    showPagination: {
      type: Boolean,
      default: true
    }

  },

  computed: {
    url: function () {
      return 'files-recent-rtx' + (this.org().id ? '/' + this.org().id : '/null') +
       (this.type ? '/' + this.type : '') +
       (this.typeId ? '/' + this.typeId : '')

/*
      return '/files-recent/' + (this.siteId
        ? 'site/' + this.siteId + '/' + this.type : this.type) +
         (this.typeId ? '/' + this.typeId : '') +
         (this.step ? (this.siteId ? '/' : '/null/null/') + this.step + (this.partyNo ? '/' + this.partyNo : '/null')
        : (this.siteId ? '/null' : '/null/null') + (this.partyNo ? '/' + this.partyNo : '/null'))
*/
    }
  },

  watch: {
    stepData (value) {

      if (this.addProps.copyExisting && value && value.stepNo) {
        this.addProps.copyExisting.step = value.stepNo
        this.addProps.copyExisting.partyNo = this.partyNo
      }
    }
  },

  methods: {
    getTableRef () {
      return this.tableRef + '-' + (this.partyNo ? this.partyNo : this.rand)
    },

    formatStatus (value) {

      if (value) {

        switch (value) {
          case 'Closed': return 'text-success'
        }

        switch (value) {
          case 'Rejected': return 'text-warning'
        }

      }
      return 'text-primary'
    },


    formatRequest (value) {
      let cls = 'pull-right '

      switch (value) {
        case 'RTS':
          cls += 'text-success'
          break

        case 'RTU':
          cls += 'text-primary'
          break

        case 'RTB':
          cls += 'text-info'
          break

      }

      return cls
    },

    formatKiloBytes (value) {
      if (value && value > 0) {
        return this.formatInteger(value / 1000) + 'k'
      } else {
        return ''
      }
    },

    filler (value) {
      return '<span style="width: 100%; color: transparent;">' + value + '</span>'
    },

    refreshTable () {
      this.$events.fire(this.getTableRef() + '-refresh-table')
    },

    getModelKey (id) {
      return this.getTableRef() + 'Upload' + id
    },

    getModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      if (arr) {
        return arr
      } else {
        this.fileUploads.push({[key]: []})
        return this.key(key, this.fileUploads)
      }
    },

    clearModel (id) {
      var key = this.getModelKey(id)
      var arr = this.key(key, this.fileUploads)

      if (arr) {
        arr = []
        this.fileUploads.push({[key]: []})
      }
    },

    getType (row) {
      return row.approved
          ? 'success' : row.downloaded
          ? 'info' : (row.state && row.state.status === 'Rejected' ? 'danger' : 'warning')
    },

    disableUpload (row) {

      if (this.stepData && this.stepData.stepNo) {
        return !(row.step === this.stepData.stepNo && row.partyNo === this.stepData.partyNo)
      } else {
        return false
      }
    },

    uploaded (file, fileList) {
      this.refreshTable()
      fileList = []

      if (this.uploadCallback) {
        this.uploadCallback(file, this.uploadInfo)
      }

    },

    download (row) {
      var dwUrl = this.getEndpoint('file/download/' + row.url + '/' + this.userName())
      this.downloadFile(dwUrl)
    },

    afterDelete (data = null) {

      if (data) {

        this.fileData.url = null
        this.fileData.downloaded = false

        this.clearModel(data.id)
      }

      this.refreshTable()
    },

    info (rowData, stepNo) {

      var data = {
        info: {},
        sendTo: []
      }

      if (rowData && rowData.state && rowData.emails) {

        var prop = this.isTelco() ? 'tower' : 'telco'

        if (!rowData.emails[prop]) {
          console.error('OLD FORMAT for state.emails:', rowData.emails)
        } else {
          for (var i = 0; i < rowData.emails[prop].length; i++) {
            if (rowData.emails[prop][i] && !data.sendTo.includes(rowData.emails[prop][i])) {
              data.sendTo.push(rowData.emails[prop][i])
            }
          }

        }

        data.info.step = stepNo
        data.info.sendMail = rowData.emails.sendMail ? rowData.emails.sendMail : false
        data.info.rts_id = rowData.id ? rowData.id : null
        data.info.site_id = rowData.site_id ? rowData.site_id : null
        data.info.towerCoName = this.xolasClient().name ? this.xolasClient().name : 'Xolas Towers'
        data.info.email = this.xolasClient().email ? this.xolasClient().email : 'support@xolas.io'
        data.info.phone = this.xolasClient().phone ? this.xolasClient().phone : null
        data.info.siteName = rowData.site && rowData.site.siteName ? rowData.site.siteName : 'No Site Selected'
        data.info.siteId = rowData.site && rowData.site.siteId ? rowData.site.siteId : 'N/A'
        data.info.telcoSiteId = rowData.site && rowData.site.telcoSiteId ? rowData.site.telcoSiteId : 'N/A'
        data.info.sharerName = rowData.organisation && rowData.organisation.name ? rowData.organisation.name : 'No Sharer Selected'
      }
    }
  },

  data () {
    return {
      rand: null,
      fileData: this.rowData,
      addFileAction: FileAction,
      addProps: {
        showCaption: false,
        showRef: false,
        tableRef: this.getTableRef(),
        copyExisting: {
          site_id: this.siteId,
          workflow_id: this.workflow_id,
          typeKey: this.siteId ? 'site' : this.type,
          type_id: this.siteId ? this.siteId : this.typeId,
          processKey: this.siteId ? this.type : null,
          process_id: this.siteId ? this.typeId : null,
          step: this.step,
          seqNo: this.stepData ? this.stepData.seqNo : null,
          partyNo: this.partyNo ? this.partyNo : (this.stepData ? this.stepData.partyNo : null)
        }
      },
      fileUploads: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: '__slot:file-details',
          title: 'Details'
        }
      ]
    }
  },  // data

  created () {
    this.rand = (this.rand ? this.rand : this.randBetween())

    this.addProps.tableRef = this.getTableRef()
  }
}

</script>

<style scoped>
a {text-decoration: none;}
</style>
